import RenderbusTheme from "../theme/renderbus-theme";
import FoxrenderfarmTheme from "../theme/foxrenderfarm-theme";
import MiguTheme from "../theme/migu-theme";
import ClientTheme from "../theme/client-theme";
import PictureClientTheme from "../theme/picture-client-theme";

import NewRenderbusTheme from "../theme/new/renderbus-theme";
import NewFoxRenderfarmTheme from "../theme/new/foxrenderfarm-theme";
import { INewTheme } from "../theme/new";

export enum ThemeKey {
  renderbus = "renderbus",
  foxrenderfarm = "foxrenderfarm",
  migu = "migu",
  renderbus_client = "renderbus_client",
  foxrenderfarm_client = "foxrenderfarm_client",
  picture_client = "picture_client",
}

export type ThemeKeyType = keyof typeof ThemeKey;

export const ThemeMap = new Map<ThemeKeyType, object>([
  [ThemeKey.renderbus, RenderbusTheme],
  [ThemeKey.foxrenderfarm, FoxrenderfarmTheme],
  [ThemeKey.migu, MiguTheme],
  [ThemeKey.renderbus_client, { ...RenderbusTheme, ...ClientTheme }],
  [ThemeKey.foxrenderfarm_client, { ...FoxrenderfarmTheme, ...ClientTheme }],
  [ThemeKey.picture_client, { ...RenderbusTheme, ...PictureClientTheme }],
]);

export const NewThemeMap = new Map<ThemeKeyType, INewTheme>([
  [ThemeKey.renderbus, NewRenderbusTheme],
  [ThemeKey.foxrenderfarm, NewFoxRenderfarmTheme],
]);
